export default __webpack_public_path__ + "static/media/cart-transparent.4fc2a20c.svg";